import React from 'react';
import { useState, useEffect} from "react";
import { Box, IconButton, MenuItem, Select } from "@mui/material";
// import { tokens } from "../theme";
import { ColorModeContext, useMode} from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { fetchToken } from '../auth/Token';
import { Button } from '@mui/material';
import { api } from '../api'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import LoginIcon from '@mui/icons-material/Login';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import  Grid  from '@mui/material/Grid';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

const AssociationMassForm = (props) => {
    const association_id = props.association_id;
    const [members, setMembers] = useState([]);

    useEffect(() => {
        api.get(`/transactions/mass/form/${association_id}`, {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response) {
            setMembers(response.data);
        }).catch(function (error){
            console.log(error);
        })
    },[association_id])

    // const every = () =>{
    //     members.Members?.map((item) => (
    //         let formik = useFormik({
    //             initialValues: {
    //                 transactiontype_id: 1,
    //                 Amount: null,
    //                 member_name: item.firstname,
    //                 savings_acc_id: props.ID
    //             },
    //         })
    //     ))
    // };
    

    return(
        <Item>
            
        </Item>
    )
};


const MassTransaction = () => {
    const [theme, colorMode] = useMode();
    const [isSidebar, setIsSidebar] = useState(true);
    const [OpenForm, setOpenForm] = useState();
    const [AllAssociations, setAllAssociations] = useState([]);


   
      useEffect(() => {
        api.get('/association/goto/form', {
            headers: {
                Authorization: 'Bearer '+fetchToken()
            },
        }).then(function (response) {
            setAllAssociations(response.data);
        }).catch(function (error) {
            console.log(error);
        });
      },[])

      const handleAssociationForm = (association_id) => {
        setOpenForm(<AssociationMassForm association_id={association_id} />)
      };
    

    return (
                    <div className="app">
                            <main className="content">
                                    <Box sx={{m:5}}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Header title="Transactions" subtitle="Multiple Transactions" />
                                        </Box>
                                        <Divider variant="middle" />
                                        <Grid container spacing={2}>
                                        {AllAssociations.All_Associations?.map((item) => (
                                        <Grid item  md={4}> 
                                        <Card sx={{ minWidth: 280, margin: 4 }}>
                                            <CardContent>
                                            <Typography gutterBottom variant="h5" component="div">
                                                {item.association_name} 
                                            </Typography>
                                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                {item.association_type}
                                                </Typography>
                                            </CardContent>
                                            <CardActions>
                                            <IconButton onClick={() => handleAssociationForm(item.association_id)} >
                                               <LoginIcon />
                                            </IconButton>
                                            </CardActions>
                                        </Card>
                                        </Grid>
                                        ))}
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                {OpenForm}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    
                            </main>
                    </div>
    )
}

export default MassTransaction;